import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
    asyncCreateSupportMessageAction,
    asyncGetSupportAction,
} from "./supportsAction";
import { ISupportMessage } from "../../../helpers/types";


interface supportsState {
    supports: ISupportMessage[];
    support: ISupportMessage | null;
    totalSupports: number;
    isLoading: boolean;
    error: string;
}

const initialState: supportsState = {
    supports: [],
    support: null,
    totalSupports: 0,
    isLoading: false,
    error: ''
};


const supportsSlice = createSlice({
    name: 'supportsSlice',
    initialState,
    reducers: {
        addSupportMessage(state,action) {
            state.supports = [...state.supports,action.payload];
        },
        resetSupports(state) {
            state = initialState;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(asyncGetSupportAction.fulfilled, (state: supportsState, action: PayloadAction<any>) => {
                const {rows, count} = action.payload;
                state.isLoading = false;
                state.error = '';
                state.supports = rows;
            })
            .addCase(asyncGetSupportAction.pending, (state: supportsState, action: PayloadAction<any>) => {
                state.isLoading = true;
            })
            .addCase(asyncGetSupportAction.rejected, (state: supportsState, action: PayloadAction<any>) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(asyncCreateSupportMessageAction.fulfilled, (state: supportsState, action: PayloadAction<any>) => {
                state.isLoading = false;
                state.error = '';
                state.supports = [...state.supports,action.payload];
            })
            .addCase(asyncCreateSupportMessageAction.pending, (state: supportsState, action: PayloadAction<any>) => {
                state.isLoading = true;
            })
            .addCase(asyncCreateSupportMessageAction.rejected, (state: supportsState, action: PayloadAction<any>) => {
                state.isLoading = false;
                state.error = action.payload;
            })


    }
});

export const {addSupportMessage, resetSupports } = supportsSlice.actions;
export default supportsSlice.reducer;
